import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The following self-hosted proxy isn't provided by PostHog, so we can't take responsibility for it! If unsure, we recommend using `}<a parentName="p" {...{
        "href": "/docs/advanced/proxy/managed-reverse-proxy"
      }}>{`our managed reverse proxy`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      